import { GetContentsQuery, GetProfileContentsQuery } from '@diritto/common/api/ContentApi';
import { GetFavoriteQuery, GetRecentlyReadQuery } from '@diritto/common/api/RelayContentApi';
import { QueryKey } from 'constants/reactQuery';

export const contentsQueryKey = {
  contents: [QueryKey.Content] as const,
  content: (id: number) => [...contentsQueryKey.contents, id] as const,
  contentList: (options: GetContentsQuery) => [...contentsQueryKey.contents, options] as const,
  contentEventList: (id: number) => [...contentsQueryKey.content(id), 'event'] as const,

  profileContentList: (profileId: number, options: GetProfileContentsQuery) =>
    [QueryKey.Content, QueryKey.Profile, profileId, options] as const,

  recentlyReads: [QueryKey.RecentlyRead] as const,
  recentlyReadList: (options: GetRecentlyReadQuery) => [...contentsQueryKey.recentlyReads, options] as const,

  favorites: [QueryKey.Favorite] as const,
  favoritesList: (options: GetFavoriteQuery) => [...contentsQueryKey.favorites, options] as const,
};
